"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_empty_1 = require("../arrays/is-empty");
class ValidationResult {
    constructor(errors, isSuccessful = is_empty_1.isEmpty(errors)) {
        this.errors = errors;
        this.isSuccessful = isSuccessful;
    }
}
exports.ValidationResult = ValidationResult;
//# sourceMappingURL=validation-result.js.map